// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"7f7fd839","80":"75926601"}[chunkId] + ".chunk.js";
};